import { type ReactNode } from 'react';

import { cn } from '../../utils/cn';

interface FilterPillProps {
  active: boolean;
  tone: string;
  ring?: string;
  title?: string;
  onClick: () => void;
  children: ReactNode;
}

export const FilterPill = ({
  active,
  tone,
  ring = 'ring-slate-400',
  title,
  onClick,
  children,
}: FilterPillProps) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    className={cn(
      'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-medium transition',
      tone,
      active ? cn('ring-2 ring-offset-1 shadow-sm', ring) : 'opacity-80 hover:opacity-100',
    )}
  >
    {children}
  </button>
);
